module.exports = require("./ff-Adlm-MR.d.ts");